import {useSearchParams} from 'react-router-dom';

import Stack from '@mui/material/Stack';

import useUser from '../../hooks/useUser';
import AppDashboard from '../AppDashboard';
import ExistingPatientBookingForm from '../../components/booking/ExistingPatientBookingForm';

const ExistingPatientBookingPage = props => {
  const user = useUser();
  const [search] = useSearchParams();
  const searchMethod = search.get('searchMethod');
  // if (!searchMethod) return <PatientWaysToBook />;
  return (
    <AppDashboard
      title="Schedule a Session"
      loading={!user}
      hideBack={true}
      showUser
    >
      <Stack pt={2}>
        <ExistingPatientBookingForm 
          searchMethod={searchMethod} 
        />
      </Stack>
    </AppDashboard>
  );
};

export default ExistingPatientBookingPage;